import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { Fragment } from 'react';
import { MyTrans } from '@halo/ui-react';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupRemoveMemberContentProps {
  message: Msg;
}

export const MsgGroupRemoveMemberContent = memo(function MsgGroupRemoveMemberContent({
  message,
}: MsgGroupRemoveMemberContentProps) {
  const { t } = useTranslation();
  const { user_name, member, user_id, remove_total_count } = message.payload;
  const count = remove_total_count - (member?.length ?? 0);

  return (
    <MyTrans
      i18nKey={
        count > 0
          ? t('chat.groupMessageRemoveMemberTextOther')
          : t('chat.groupMessageRemoveMemberTextOne')
      }
      components={{
        actionUser: <MsgUserText userName={user_name} userId={user_id} />,
        action: <Text as="span" color="fg.muted" />,
        members: (
          <>
            {member?.map((item: any, index: number) => (
              <Fragment key={index}>
                {index > 0 && ', '}
                <MsgUserText userName={item.user_name} userId={item.user_id} />
              </Fragment>
            ))}
          </>
        ),
        other: <Text as="span" color="fg.muted" />,
      }}
      values={{
        count,
      }}
    ></MyTrans>
  );
});
